import React, { useRef } from 'react';
import { FileUpload } from 'primereact/fileupload';
import activeAccessApi from '../api/activeAccessApi';

const MAX_LOGO_SIZE = 2 * 1024 * 1024;
const ACCEPTED_TYPES = ['image/png', 'image/jpeg', 'image/webp'];
const ACCEPTED_EXTENSIONS = /\.(png|jpe?g|webp)$/i;

const ActiveAccessLogoUpload = ({ customerId, disabled, uploading, onUploadStart, onUploaded, onError }) => {
  const uploadRef = useRef(null);

  const uploadFile = async (event) => {
    const file = event.files && event.files[0];
    if (!file) return;

    if (ACCEPTED_TYPES.indexOf(file.type) === -1 || !ACCEPTED_EXTENSIONS.test(file.name || '')) {
      onError('Logo must be a PNG, JPG, JPEG, or WEBP image.');
      return;
    }

    if (file.size > MAX_LOGO_SIZE) {
      onError('Logo must be no larger than 2 MB.');
      return;
    }

    try {
      onUploadStart();
      const upload = await activeAccessApi.createActiveAccessBrandingUploadUrl(customerId, {
        fileName: file.name,
        contentType: file.type,
        imageType: 'logo',
      });
      const response = await fetch(upload.uploadUrl, {
        method: 'PUT',
        headers: upload.headers,
        body: file,
      });
      if (!response.ok) throw new Error('Upload failed');
      onUploaded(upload.imageSource);
    } catch (error) {
      const data = error && error.response && error.response.data;
      if (error && error.response && error.response.status === 400 && typeof data === 'string' && data.trim()) {
        onError(data);
      } else if (error && error.response && error.response.status === 400 && data && typeof data === 'object') {
        onError(data.detail || data.title || 'Unable to prepare logo upload.');
      } else if (error && !error.response) {
        onError('Upload failed, please try again');
      } else {
        onError('Unable to prepare logo upload.');
      }
    } finally {
      if (uploadRef.current) uploadRef.current.clear();
    }
  };

  return <FileUpload ref={uploadRef} mode="basic" name="logo" accept=".png,.jpg,.jpeg,.webp,image/png,image/jpeg,image/webp" chooseLabel={uploading ? 'Uploading main page image...' : 'Upload'} customUpload uploadHandler={uploadFile} auto disabled={disabled || uploading} chooseOptions={{ icon: 'pi pi-upload', className: 'p-button-outlined' }} />;
};

export default ActiveAccessLogoUpload;